import Rotate from "../../../features/tools/object/rotate/Editor/Rotate";
import Flip from "../../../features/tools/object/flip/Editor/Flip";
import Shadow from "../../../features/tools/object/shadow/Editor/Shadow";
import Outline from "../../../features/tools/object/outline/Editor/Outline";

const BatchEditorObjectPanel = () => {
  return (
    <div>
      <Rotate />
      <Flip />
      <Shadow />
      <Outline />
    </div>
  );
};

export default BatchEditorObjectPanel;
